<template>
  <div class="comment-body">
    <slot v-if="highlight">
      <p
        v-if="title"
        class="comment-title break-word-all"
      >
        <highlight-text
          :keyword="highlight"
          :over-write-style="highlightStyle"
          :sensitive="false"
        >
          {{ title }}
        </highlight-text>
      </p>
      <p
        v-for="(line, index) in parseCommentBody"
        :key="line + index"
        class="break-word-all"
      >
        <highlight-text
          :keyword="highlight"
          :over-write-style="highlightStyle"
          :sensitive="false"
        >
          {{ line }}
        </highlight-text>
      </p>
    </slot>
    <slot v-else>
      <p
        v-if="title"
        class="comment-title break-word-all"
      >
        {{ title }}
      </p>
      <p
        v-for="(line, index) in parseCommentBody"
        :key="line + index"
        class="break-word-all"
      >
        {{ line }}
      </p>
    </slot>
    <em
      v-if="showModMessage"
      class="comment-mod-message mt-3"
    >
      Thank you for submitting! To keep our community as helpful as
      possible, we moderate all comments and reviews.
    </em>
  </div>
</template>

<script>
import HighlightText from 'vue-highlight-text';

export default {
  name: 'PDPCommentBody',
  components: {
    HighlightText,
  },
  props: {
    comment: {
      type: String,
      default: '',
    },
    showModMessage: {
      type: Boolean,
    },
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
    };
  },
  computed: {
    highlight() {
      return this.$store.getters['discussion/searchTerm'];
    },
    parseCommentBody() {
      return this.comment.split(/\r\n?|\n/).filter((i) => i);
    },
    highlightStyle() {
      return { color: 'initial', 'background-color': 'rgba(255,188,0,0.5)' };
    },
  },
};
</script>

<style lang="scss" scoped>
  p {
    font-weight: 300;
  }

  /* stylelint-disable selector-no-qualifying-type */
  p.comment-title {
    font-weight: 700;
  }

  p.comment-mod-message {
    font-weight: 300;
    font-size: 0.9rem;
  }
  /* stylelint-enable selector-no-qualifying-type */
</style>
